<template>
  <div>
    <div class="client_mobile">
      <img :src="client_mobile" />
    </div>
      <div class="client_wrap" :style="{ background: 'url(\'' + client_pc + '\') no-repeat center top' }">
      <div class="gift-txt txt-center">
        <!-- <p>
          안녕하세요.<br />
          캐럿입니다~!<br /><br />
          항상 캐럿에 많은 관심과<br />
          응원 보내주셔서 감사드립니다.<br /><br />
          항상 평안과 건강이 함께하길 기원합니다.<br /><br />
          추석을 맞이하여 책을 한 권 보내드립니다.<br />
          책과 함께 마음이 여유로운<br />
          연휴 보내시기 바랍니다.<br />
        </p>
        <p class="from">
          ㈜캐럿글로벌 <br />
          CEO 노 상 충 배상
        </p> -->
      </div>
    </div>
    <div class="apply_btn txt-center">
      <p style="font-size: 16px">
          선물이 도착할 배송지를 입력해 주세요.<br />(마감일은 {{ end_date_text }}까지
          입니다.)
        </p>
      <br />
      <button @click="clickApply()" class="layer_show pointer">
        배송지 입력하기 <span>></span>
      </button>
    </div>
    <!-- 레이어팝업 -->
    <div v-if="isInputPop" class="carrot_layer">
      <div class="gift_pop_wrap">
        <div class="pop_cont">
          <div class="pop_contact">
            <form name="formApply" id="formApply" enctype="multipart/form-data">
              <div id="layer" class="pop_layer">
                <div class="layer_top">
                  <h2 class="gifth2">배송지 입력</h2>
                  <a
                    @click="clickClose()"
                    class="layer_close"
                    style="cursor: pointer"
                  >
                  <img src="../assets/img/holiday/layer_close.png" />
                  </a>
                </div>
                <div class="layer_con">
                  <div class="box_form">
                    <p>이름</p>
                    <input
                      v-model="name"
                      placeholder="이름을 입력해주세요."
                      type="text"
                      name="name"
                      class="txt"
                    />
                  </div>
                  <div class="box_form">
                    <p>연락처</p>
                    <input
                      type="text"
                      v-model="mobile1"
                      class="txt2"
                      name="mobile1"
                      id="mobile1"
                      maxlength="3"
                    />&nbsp;&nbsp;-&nbsp;&nbsp;
                    <input
                      type="text"
                      v-model="mobile2"
                      class="txt2"
                      name="mobile2"
                      id="mobile2"
                      maxlength="4"
                    />&nbsp;&nbsp;-&nbsp;&nbsp;
                    <input
                      type="text"
                      v-model="mobile3"
                      class="txt2"
                      name="mobile3"
                      id="mobile3"
                      maxlength="4"
                    />
                    <span class="file_plus"></span>
                  </div>
                </div>
                <div class="layer_con_wrap">
                  <div class="layer_con2">
                    <p class="dp-inblock">배송지</p>
                    <div class="dp-inblock">
                      <input
                        type="text"
                        v-model="code"
                        placeholder="우편번호"
                        class="post_box"
                        @click="ShowPostcode()"
                        readonly
                      />
                      <a class="search_btn" @click="ShowPostcode()">검색</a>
                      <br />
                      <input
                        type="text"
                        v-model="addr"
                        placeholder="배송 받을 주소를 입력해주세요."
                        readonly
                      />
                      <br />
                      <input
                        type="text"
                        v-model="detailsAddr"
                        placeholder="상세 주소를 입력해주세요."
                        style="margin-top: 5px"
                      />
                    </div>
                    <div id="addr_wrap" class="addr-wrap cb">
                      <img
                        v-show="isSearch"
                        src="../assets/img/holiday/btn_addr_close.png"
                        class="btn-addr-hide"
                        @click="HidePostcode()"
                        alt="접기 버튼"
                      />
                    </div>
                    <div class="checkT">
                      <p class="layer_info">
                        ※ 입력된 개인정보는 선물 발송 이외의 용도로는 사용되지
                        않으며, 발송 이후 파기됩니다.
                      </p>
                      <input
                        type="checkbox"
                        v-model="agree"
                        style="cursor: pointer"
                      />
                      <a style="cursor: pointer" @click="personalDataAgree"
                        >개인정보 수집 및 이용에 동의합니다.</a
                      >
                    </div>
                    <div v-show="isPersonalData" class="termsWrap">
                      <!-- <div class="termsWrap"> -->
                      <div class="terms_title">
                        <h5>개인정보 수집 및 이용</h5>
                        <a @click="agreeClose" style="cursor: pointer">
                          <img
                            src="../assets/img/holiday/btn_check_close.png"
                          />
                        </a>
                      </div>
                      <div class="terms_summary">
                        1. 개인정보의 수집 및 이용 목적 <br />
                        입사전형 진행, 입사지원서 수정, 자격요건의 확인,
                        합격여부 확인, 지원자와의 원활한 의사소통 경로 확보,
                        특정금융정보법에 따른 신원확인 <br />
                        <br />
                        2. 수집하는 개인정보의 항목 <br />
                        [필수항목] : 성명, 확인용 비밀번호, 이메일 주소,
                        전화번호, 생년월일, 성별, 국적, 학력사항(학교명,
                        입학/졸업년월, 전공, 세부전공, 성적, 졸업구분),
                        경력사항(회사명, 직무, 직위, 부서명, 재직기간), 병역사항
                        <br />
                        [선택항목] : 경력사항(신입인 경우), 자격/어학사항(자격
                        종류, 등급, 점수, 취득일), 보훈사항(대상인 경우),
                        장애사항(대상인 경우) <br />
                        <br />
                        3. 개인정보의 보유 및 이용기간 <br />
                        입사지원자의 개인정보는 회사의 인력풀에 저장되어 채용이
                        필요한 경우 해당 인력풀에서 상시채용을 위해 5년 동안
                        보관합니다. 인력풀에 보관된 개인정보는 지원하신 부서
                        외의 채용에도 검토될 수 있으며, 불합격 시에도 추후
                        채용을 검토할 수 있는 지원서로 활용됩니다. <br />
                        다만, 입사지원자가 개인정보의 삭제를 원하는 경우 지체
                        없이 해당 정보를 삭제합니다. <br />
                        <br />
                        4. 동의를 거부할 권리 및 동의 거부에 따른 불이익 <br />
                        지원자는 개인정보의 수집, 이용 등과 관련한 위 사항에
                        대하여 원하지 않는 경우 동의를 거부할 수 있습니다. 다만,
                        수집하는 개인정보의 항목에서 필수정보에 대한 수집 및
                        이용에 대하여 동의하지 않는 경우는 채용전형에 제한이
                        있을 수 있습니다. <br />
                      </div>
                    </div>
                    <div class="finish_btn">
                      <a href="#" class="layer_ok" @click="saveApply">완료</a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HolidayGiftClient",

  data() {
    return {
      isInputPop: false,
      element_wrap: document.getElementById("addr_wrap"),
      code: "",
      addr: "",
      detailsAddr: "",
      name: "",
      mobile1: "",
      mobile2: "",
      mobile3: "",
      isPersonalData: false,
      agree: "",
      isSearch: false,
      isStart: false,
      isFinish: true,

      client_pc : '',
      client_mobile : '',
      end_date_text: '',
      end_date: '',
    };
  },
  mounted() {
    let url = "";
    if (location.href.includes("local") || location.href.includes("stage")) {
        url = "https://stageapi.carrotians.net/rest/external/getHolidayGiftManagement";
      } else {
        url = "https://api.carrotians.net/rest/external/getHolidayGiftManagement";
      }
      this.axios.get(url).then((res) => {
        this.client_pc = res.data.data.client_pc
        this.client_mobile = res.data.data.client_mobile
        this.end_date_text = res.data.data.end_date_text
        this.end_date = res.data.data.end_date
      })
    },
  methods: {
    clickClose() {
      this.isInputPop = false;
    },
    clickApply() {
      // 현재 날짜와 시간을 가져오기
      const now = new Date();
      // 9월 13일 23:59:59를 나타내는 날짜와 시간을 생성
      const deadline = new Date(this.end_date);
      // 23:59:59를 나타내는 시간으로 변경
      deadline.setHours(23, 59, 59, 999);
      // 현재 시간이 마감 시간 이후인지 확인
      if (now > deadline) {
        // 마감 시간 이후에 클릭된 경우
        alert("배송지 입력이 마감되었습니다.\n\n감사합니다.");
      } else {
        // 마감 시간 이전에 클릭된 경우, 원래 코드 실행
        this.isInputPop = true;
      }
    },

    HidePostcode() {
      let element_wrap = document.getElementById("addr_wrap");
      //iframe을 넣은 element를 안보이게 한다.
      element_wrap.style.height = 0;
      setTimeout(function () {
        element_wrap.style.display = "none";
      }, 400);
    },
    ShowPostcode() {
      this.isSearch = true;
      let element_wrap = document.getElementById("addr_wrap");
      //현재 스크롤 위치
      let that = this;
      let currentScroll = Math.max(
        document.body.scrollTop,
        document.documentElement.scrollTop
      );
      new daum.Postcode({
        oncomplete: function (data) {
          that.isSearch = false;
          that.HidePostcode();
          var fullAddr = data.address; // 최종 주소 변수
          var extraAddr = ""; // 조합형 주소 변수
          // 기본 주소가 도로명 타입일때 조합한다.
          if (data.addressType === "R") {
            //법정동명이 있을 경우 추가한다.
            if (data.bname !== "") {
              extraAddr += data.bname;
            }
            // 건물명이 있을 경우 추가한다.
            if (data.buildingName !== "") {
              extraAddr +=
                extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
            }
            // 조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종 주소를 만든다.
            fullAddr += extraAddr !== "" ? " (" + extraAddr + ")" : "";
          }
          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          that.code = data.zonecode;
          that.addr = fullAddr;
          document.body.scrollTop = currentScroll;
        },
        onresize: function (size) {
          element_wrap.style.height = size.height + "px";
        },
        width: "100%",
        height: "100%",
      }).embed(element_wrap);

      element_wrap.style.display = "block";
    },
    saveApply() {
      if (this.isNull(this.name)) {
        alert(`이름을 입력해 주세요`);
        return;
      }
      if (this.isNull(this.mobile1)) {
        alert(`연락처 첫번째 자리를 입력해주세요`);
        return;
      }
      if (this.isNull(this.mobile2)) {
        alert(`연락처 두번째 자리를 입력해주세요`);
        return;
      }
      if (this.isNull(this.mobile3)) {
        alert(`연락처 세번째 자리를 입력해주세요`);
        return;
      }
      if (this.isNull(this.code)) {
        alert(`우편번호를 입력해주세요`);
        return;
      }
      if (this.isNull(this.addr)) {
        alert(`주소를 입력해주세요`);
        return;
      }
      if (this.isNull(this.detailsAddr)) {
        alert("상세주소를 입력해주세요.");
        return;
      }
      if (this.agree == false) {
        alert("개인정보 수집 및 이용에 동의 하신 후 등록가능합니다.");
        return;
      }
      let data = JSON.stringify({
        type: "client",
        name: this.name,
        mobile: this.mobile1 + "-" + this.mobile2 + "-" + this.mobile3,
        postcode: this.code,
        addr: this.addr + '  ' + this.detailsAddr,
      });
      let url = "";

      if (location.href.includes("local") || location.href.includes("stage")) {
        url = "https://stageapi.carrotians.net/rest/external/addHolidayGift";
      } else {
        url = "https://api.carrotians.net/rest/external/addHolidayGift";
      }
      this.axios
        .post(url, data)
        .then((res) => {
          alert(`신청이 완료되었습니다.`);
          // alert('입력이 완료되었습니다.')
          this.$router.push({ path: "finish" });
        })
        .catch((err) => {
          alert("통신이 원활하지 않습니다.");
          console.log("err : " + err);
        });
    },
    personalDataAgree() {
      this.agree = true;
      this.isPersonalData == true
        ? (this.isPersonalData = false)
        : (this.isPersonalData = true);
    },
    agreeClose() {
      this.isPersonalData = false;
    },
    isNull(value) {
      if (value == "" || value == null || value == undefined) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/style/holiday_gift/common.css";
@import "../assets/style/holiday_gift/style.css";
@import url("https://fonts.googleapis.com/css?family=Nanum+Myeongjo&display=swap");
</style>
